import { createAction, props } from '@ngrx/store';

export const resetMovementsState = createAction('[Movements] Reset Movements State Action');
export const getContractMovementsList = createAction('[Movements] Get All Contract Movements List Action',
    props<{ options: any }>()); // paging?: any, filteringArgs?: any, sortingArgs?: any
export const loadContractMovementsPartyList = createAction('[Movements] Load All Contract Movements List Action Action',
    props<{ response: any[] }>());
export const getMovement = createAction('[Movements] Get a Movement by code Action', props<{ options: any }>());
export const loadMovement = createAction('[Movements] Load Movement Action Action',
    props<{ response: any }>());
export const loadMovementsLoadStart = createAction('[Movements] Load Start Action');
export const loadMovementsLoadEnd = createAction('[Movements] Load End Action');
export const updateMovement = createAction('[Movements] Update Movement Action', props<{ movement: any }>());
export const resetMovement = createAction('[Movements] Reset Movement Action');
export const getMovementsExcelList = createAction(
    "[Movements] Get All Movements Excel List Action",
    props<{ options: any }>()
  );
  export const loadMovementsExcelList = createAction(
    "[Movements] Load All Movements Excel List Action",
    props<{ response: any[] }>()
  );
// Movements Table Configuration Settings
export const getMovementTableConfig = createAction(
  "[Movements] Get Movement Table Configuration Action",
  props<{ options: any }>()
);
export const loadMovementTableConfig = createAction(
  "[Movements] Load Movement Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveMovementTableConfig = createAction(
  "[Movements] Save Movement Table Configuration Action",
  props<{ config: any }>()
);

export const setLoadingEndState = createAction("[Movements] Load End Action");
